import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    tournamentGroups: [],
    tournamentGroup: {}
  },
  mutations: {
    index(state, payload) {
      state.tournamentGroups = payload
    },
    show(state, payload) {
      state.tournamentGroup = payload
    }
  },
  actions: {
    index({ commit }) {
      axios.get(`${ENV.API_URL}/api/tournament_groups`).then((res) => {
        commit('index', res.data)
      })
    },
    show({ commit }, payload) {
      axios.get(`${ENV.API_URL}/api/tournament_groups/${payload}`).then((res) => {
        commit('show', res.data)
      })
    },
    create({ commit }, payload) {
      axios.post(`${ENV.API_URL}/api/tournament_groups`, payload).then((res) => {
        commit('show', res.data)
      })
    },
    uptade({ commit }, payload) {
      axios.put(`${ENV.API_URL}/api/tournament_groups/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
      })
    }
  },
  getters: {
    tournamentGroups: state => {
      return state.tournamentGroups
    },
    tournamentGroup: state => {
      return state.tournamentGroup
    }
  },
  modules: {
  }
}
